import { render, staticRenderFns } from "./Investing.vue?vue&type=template&id=07e0a120&scoped=true&"
import script from "./Investing.vue?vue&type=script&lang=js&"
export * from "./Investing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07e0a120",
  null
  
)

export default component.exports